import NavigationSubItem from 'apps/layout/components/navigation-sub-item';
import EverTrue from 'app';
import PropTypes from 'prop-types';
import { useIdentity } from 'base/identity-resolver';
import { Icon } from '@evertrue/et-components';
import { useState, useEffect } from 'react';
import Api from 'entities/helpers/api';
import { getMomentObjectInTimezone } from 'base/new-utils';

const NavigationFacebookLink = ({ active_path = '', isCollapsed }) => {
  const REGEX_FACEBOOK = new RegExp(`^\\/facebook\\/.*`);
  const { isOwner, isSuperUser } = useIdentity();
  const [hasDisconnectedPages, setHasDisconnectedPages] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const today = getMomentObjectInTimezone();
    const threeMonthsAgo = today.subtract(3, 'months');
    const timestamp = threeMonthsAgo.valueOf();
    Api.ENGAGEMENTS.FB_DISCONNECTED_PAGE_CHECK.get({
      disableAlerts: true,
      params: { from: timestamp },
      success: (res) => {
        setHasDisconnectedPages(!!res.has_any_disconnected);
        setLoading(false);
      },
      error: () => {
        setHasDisconnectedPages(false);
        setLoading(false);
      },
    });
  }, []);

  return (
    <NavigationSubItem
      icon="facebook"
      label="Facebook"
      isActive={!!active_path.match(REGEX_FACEBOOK)}
      onClick={() => {
        EverTrue.track.set('tab_view', { type: 'facebook' });
        EverTrue.Navigator('/facebook/pages', true);
      }}
    >
      {!loading && (isOwner || isSuperUser) && hasDisconnectedPages && (
        <span style={{ marginLeft: isCollapsed ? '5px' : '50px' }} title="One or more Facebook pages are disconnected.">
          <Icon icon="warning" style={{ color: '#f5b301' }} />
        </span>
      )}
    </NavigationSubItem>
  );
};

NavigationFacebookLink.propTypes = {
  active_path: PropTypes.string,
  isCollapsed: PropTypes.bool,
};

export default NavigationFacebookLink;
